import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getMovimento(movimentoId: any) {
  const data = await api.get(`${URLS.MOVIMENTOS_API}/${movimentoId}`)
  .then((resp => resp.data));

  return data;
}
